import { render, staticRenderFns } from "./success.vue?vue&type=template&id=cbea2006&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"
import style0 from "./success.vue?vue&type=style&index=0&id=cbea2006&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbea2006",
  null
  
)

export default component.exports